import React from 'react';
import { Save, Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { toast } from 'sonner';

export const GeneralSettingsTab = () => {
  return (
    <Card className="rounded-xl border-slate-200 shadow-sm">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Globe className="h-5 w-5" />
          General Settings
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Site Name</Label>
          <Input defaultValue="PropFirmHouse" className="mt-2" />
        </div>
        <div>
          <Label>Site Tagline</Label>
          <Input defaultValue="Compare and Review Prop Trading Firms" className="mt-2" />
        </div>
        <div>
          <Label>Site Description</Label>
          <Textarea
            defaultValue="The ultimate resource for comparing proprietary trading firms."
            className="mt-2"
            rows={3}
          />
        </div>
        <div>
          <Label>Contact Email</Label>
          <Input defaultValue="admin@propfirmhouse.com" type="email" className="mt-2" />
        </div>
        <div className="flex items-center justify-between pt-4">
          <div>
            <Label>Maintenance Mode</Label>
            <p className="text-xs text-slate-500">Put site in maintenance mode for visitors</p>
          </div>
          <Switch />
        </div>
        <Button onClick={() => toast.success('Settings saved')}>
          <Save className="h-4 w-4 mr-2" />
          Save Changes
        </Button>
      </CardContent>
    </Card>
  );
};